var map = {
	"./Contact": 5615,
	"./Contact.js": 5615,
	"./Index": 9807,
	"./Index.js": 9807,
	"./Services": 6555,
	"./Services.js": 6555,
	"./Team": 2414,
	"./Team.js": 2414,
	"./css/Index.css": 7490,
	"./css/contact.css": 7970,
	"./css/contact1.css": 9673,
	"./css/home1.css": 2128,
	"./css/home1_2.css": 995,
	"./css/home2.css": 3667,
	"./css/home3.css": 5134,
	"./css/service.css": 1155,
	"./css/service1.css": 270,
	"./css/service2.css": 6493,
	"./css/service3.css": 5344,
	"./css/team1.css": 5438,
	"./img/charts.png": 4700,
	"./img/chartsb.png": 1348,
	"./img/davidpic.png": 8837,
	"./img/diferencia.png": 9757,
	"./img/first.png": 5189,
	"./img/gpt.png": 2652,
	"./img/htmltag.png": 5926,
	"./img/htmltagb.png": 3910,
	"./img/meeting.png": 3548,
	"./img/mega.png": 6957,
	"./img/megab.png": 5291,
	"./img/pfp.PNG": 6120,
	"./img/section1bg.jpg": 9636,
	"./img/servicebackground.png": 770,
	"./img/stefpic.jpeg": 1840,
	"./img/testingAnime.gif": 2784,
	"./img/voilaLogo.jpeg": 1018,
	"./img/voilaLogoLetras.png": 5086,
	"./img/voilaLogoLetrasPurple.png": 228,
	"./img/voilalogomin.png": 1825,
	"./img/voilalogominwhite.png": 2282,
	"./img/whatsapp.png": 8461,
	"./json/home": 4584,
	"./json/home.json": 4584,
	"./json/servicesData": 375,
	"./json/servicesData.json": 375,
	"./json/team": 8374,
	"./json/team.json": 8374,
	"./methods/scroll": 7265,
	"./methods/scroll.js": 7265,
	"./subpages/contact/contact1": 1322,
	"./subpages/contact/contact1.js": 1322,
	"./subpages/home/effects/AnimatedContent": 8943,
	"./subpages/home/effects/AnimatedContent.js": 8943,
	"./subpages/home/effects/Orb": 9753,
	"./subpages/home/effects/Orb.css": 8895,
	"./subpages/home/effects/Orb.js": 9753,
	"./subpages/home/effects/typing": 6198,
	"./subpages/home/effects/typing.js": 6198,
	"./subpages/home/home1": 354,
	"./subpages/home/home1 backup": 7458,
	"./subpages/home/home1 backup.js": 7458,
	"./subpages/home/home1.js": 354,
	"./subpages/home/home1_2": 135,
	"./subpages/home/home1_2.js": 135,
	"./subpages/home/home2": 4543,
	"./subpages/home/home2.js": 4543,
	"./subpages/home/home3": 1384,
	"./subpages/home/home3.js": 1384,
	"./subpages/services/effects/CircleSlideShow": 1802,
	"./subpages/services/effects/CircleSlideShow.js": 1802,
	"./subpages/services/service1": 5437,
	"./subpages/services/service1.js": 5437,
	"./subpages/services/service2": 3588,
	"./subpages/services/service2.js": 3588,
	"./subpages/services/service3": 1531,
	"./subpages/services/service3.js": 1531,
	"./subpages/team/team1": 4666,
	"./subpages/team/team1.js": 4666
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8399;